<template>
  <div>
    <v-data-table :headers="headers" :items="Federations" sort-by="Id" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" v-if="canManageAllFederations">Créer une Fédération</v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-form ref="federationForm">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field
                          v-model="editedItem.name"
                          label="Nom de la Fédération"
                          :rules="[rules.required, rules.counter]"
                          counter
                          maxlength="60"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="submitForm(editedItem)">{{ isEditing ? "Modifier" : "Créer" }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.action`]="{ item }" v-if="canManageAllFederations">
        <v-icon class="mr-2" @click="navigateToFederation(item)">mdi-open-in-app</v-icon>
        <v-icon class="mr-2" @click="openFederationDialog(item)">edit</v-icon>
        <v-icon @click="deleteFederation(item)">delete</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { getAllFederationsAsync, updateFederationAsync, createFederationAsync, deleteFederationAsync } from "../../api/federationsApi";
import { VDataTable } from "vuetify/lib";
import store from "@/store";
import PermissionsService from "@/services/PermissionsService";

export default {
  components: {
    VDataTable,
  },

  data: () => ({
    dialog: false,
    headers: [
      { text: "Id Fédération", value: "id", sortable: true },
      {
        text: "Nom de la Fédération",
        value: "name",
        sortable: false,
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    disciplines: [],
    editedIndex: -1,
    isEditing: false,
    editedItem: {},
    Federations: [],
    rules: {
      required: (value) => !!value || "Requis.",
      counter: (value) => (value ? value.length <= 60 : "Max 60 caractères"),
    },
  }),

  computed: {
    canViewAllFederations() {
      return PermissionsService.FederationsPermissionsService.canViewAllFederations;
    },
    canManageAllFederations() {
      let permission = PermissionsService.FederationsPermissionsService.canManageAllFederations;
      // If we don't have the permission to manage Federations, we wanna remove the actions header from the datatable
      if (!permission && this.headers.find((h) => h.text == "Actions")) {
        this.headers = this.headers.filter((h) => h.text != "Actions");
      }

      return permission;
    },
  },

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },

  mounted() {
    // Check if the user can see this page
    if (!this.canViewAllFederations) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    this.initializeList();
  },

  methods: {
    // Get the list of all federations
    async initializeList() {
      this.Federations = await getAllFederationsAsync();
    },

    // navigate to the federation panel
    navigateToFederation(item) {
      this.$router.push({
        name: "FederationPanel",
        params: {
          federationId: item.id,
          tab: "users",
        },
      });
    },

    // CREATE or UPDATE a federation
    async submitForm(federation) {
      // Validate the form
      var isFormValid = this.$refs.federationForm.validate();

      // If the form is valid
      if (isFormValid) {
        var result = !this.isEditing ? await createFederationAsync(federation) : await updateFederationAsync(federation.id, federation);

        // If we have an id > 0 in the result, the save succeeded
        if (result && result.id > 0) {
          var createdOrUpdatedMessage = !this.isEditing ? "créée" : "mise à jour";

          store.dispatch("setSnackbar", {
            title: `Fédération ${createdOrUpdatedMessage}`,
            text: `La fédération a bien été ${createdOrUpdatedMessage}.`,
            status: "success",
            timeout: 2000,
          });

          this.editedItem = {};
          this.$refs.federationForm.reset();
          this.isEditing = false;
        }

        this.closeDialog();

        await this.initializeList();
      }
      // Else display the error messages
      else {
        // Handle missing name
        if (!federation.name) {
          store.dispatch("setSnackbar", {
            title: "Titre requis",
            text: "Veuillez renseigner le Titre.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    editFederation(item) {
      this.editedItem = item;
      this.isEditing = true;
      this.dialog = true;
    },

    // Delete a federation
    async deleteFederation(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette fédération ?")) {
        var result = await deleteFederationAsync(item.id);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Fédération supprimée",
            text: "La fédération a bien été supprimée.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // Open the federation dialog
    openFederationDialog(item = null) {
      // If we are in edit mode
      if (item) {
        this.editedItem = item;
        this.isEditing = true;
      } else {
        this.isEditing = false;
      }
      this.dialog = true;
    },

    // Close the federation dialog
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
